"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_constants_1 = require("../../form-constants");
exports.defaultValues = {
    type: form_constants_1.dataFormatType.NONE,
};
//# sourceMappingURL=data-format.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/data-format/data-format.js
// module id = 1138
// module chunks = 0